module.exports = __webpack_public_path__ + "static/media/2-diskoteki.ec01cdb6.jpg";